import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumUserPermission implements BaseEnumType {
  private static allValues: EnumUserPermission[] = []; // make sure this is top-most
  
  public static unknown = new EnumUserPermission(0, "Unknown", "enum_user_permission_unknown");
  public static ordersView = new EnumUserPermission(1, "OrdersView", "enum_user_permission_orders_view");
  public static ordersEdit = new EnumUserPermission(2, "OrdersEdit", "enum_user_permission_orders_edit");
  public static creditNotesView = new EnumUserPermission(3, "CreditNotesView", "enum_user_permission_credit_notes_view");
  public static creditNotesEdit = new EnumUserPermission(4, "CreditNotesEdit", "enum_user_permission_credit_notes_edit");
  public static outletsAndGroupsView = new EnumUserPermission(5, "OutletsAndGroupsView", "enum_user_permission_outlets_and_groups_view");
  public static outletsAndGroupsEdit = new EnumUserPermission(6, "OutletsAndGroupsEdit", "enum_user_permission_outlets_and_groups_edit");
  public static distributionManagementView = new EnumUserPermission(7, "DistributionManagementView", "enum_user_permission_distribution_management_view");
  public static distributionManagementEdit = new EnumUserPermission(8, "DistributionManagementEdit", "enum_user_permission_distribution_management_edit");
  public static distributionProcessingView = new EnumUserPermission(9, "DistributionProcessingView", "enum_user_permission_distribution_processing_view");
  public static distributionProcessingEdit = new EnumUserPermission(10, "DistributionProcessingEdit", "enum_user_permission_distribution_processing_edit");
  public static distributionApp = new EnumUserPermission(11, "DistributionApp", "enum_user_permission_distribution_app");
  public static priceListsView = new EnumUserPermission(12, "PriceListsView", "enum_user_permission_price_lists_view");
  public static priceListsEdit = new EnumUserPermission(13, "PriceListsEdit", "enum_user_permission_price_lists_edit");
  public static reporting = new EnumUserPermission(14, "Reporting", "enum_user_permission_reporting");
  public static administration = new EnumUserPermission(15, "Administration", "enum_user_permission_administration");
  public static batchesView = new EnumUserPermission(16, "BatchesView", "enum_user_permission_batches_view");
  public static batchesEdit = new EnumUserPermission(17, "BatchesEdit", "enum_user_permission_batches_edit");
  public static recipesView = new EnumUserPermission(18, "RecipesView", "enum_user_permission_recipes_view");
  public static recipesEdit = new EnumUserPermission(19, "RecipesEdit", "enum_user_permission_recipes_edit");
  public static vesselsView = new EnumUserPermission(20, "VesselsView", "enum_user_permission_vessels_view");
  public static vesselsEdit = new EnumUserPermission(21, "VesselsEdit", "enum_user_permission_vessels_edit");
  public static menuCalendarView = new EnumUserPermission(22, "MenuCalendarView", "enum_user_permission_menu_calendar_view");
  public static menuTasksView = new EnumUserPermission(23, "MenuTasksView", "enum_user_permission_menu_tasks_view");
  public static menuSalesView = new EnumUserPermission(24, "MenuSalesView", "enum_user_permission_menu_sales_view");
  public static menuContactsView = new EnumUserPermission(25, "MenuContactsView", "enum_user_permission_menu_contacts_view");
  public static menuStockView = new EnumUserPermission(26, "MenuStockView", "enum_user_permission_menu_stock_view");
  public static menuDistributionView = new EnumUserPermission(27, "MenuDistributionView", "enum_user_permission_menu_distribution_view");
  public static menuProductionView = new EnumUserPermission(28, "MenuProductionView", "enum_user_permission_menu_production_view");
  public static menuUllagesView = new EnumUserPermission(29, "MenuUllagesView", "enum_user_permission_menu_ullages_view");
  public static menuPricingView = new EnumUserPermission(30, "MenuPricingView", "enum_user_permission_menu_pricing_view");
  public static menuContainerTrackingView = new EnumUserPermission(31, "MenuContainerTrackingView", "enum_user_permission_menu_container_tracking_view");
  public static menuDutyView = new EnumUserPermission(32, "MenuDutyView", "enum_user_permission_menu_duty_view");
  public static menuReportingView = new EnumUserPermission(33, "MenuReportingView", "enum_user_permission_menu_reporting_view");
  public static menuIntegrationsView = new EnumUserPermission(34, "MenuIntegrationsView", "enum_user_permission_menu_integrations_view");
  public static menuAdministrationView = new EnumUserPermission(35, "MenuAdministrationView", "enum_user_permission_menu_administration_view");
  public static menuDistributionAppView = new EnumUserPermission(36, "MenuDistributionAppView", "enum_user_permission_menu_distribution_app_view");
  public static menuMultiTenantView = new EnumUserPermission(37, "MenuMultiTenantView", "enum_user_permission_menu_multi_tenant_view");
  public static multiTenant = new EnumUserPermission(38, "MultiTenant", "enum_user_permission_multi_tenant");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUserPermission.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumUserPermission.unknown; }
  public isOrdersView() { return this === EnumUserPermission.ordersView; }
  public isOrdersEdit() { return this === EnumUserPermission.ordersEdit; }
  public isCreditNotesView() { return this === EnumUserPermission.creditNotesView; }
  public isCreditNotesEdit() { return this === EnumUserPermission.creditNotesEdit; }
  public isOutletsAndGroupsView() { return this === EnumUserPermission.outletsAndGroupsView; }
  public isOutletsAndGroupsEdit() { return this === EnumUserPermission.outletsAndGroupsEdit; }
  public isDistributionManagementView() { return this === EnumUserPermission.distributionManagementView; }
  public isDistributionManagementEdit() { return this === EnumUserPermission.distributionManagementEdit; }
  public isDistributionProcessingView() { return this === EnumUserPermission.distributionProcessingView; }
  public isDistributionProcessingEdit() { return this === EnumUserPermission.distributionProcessingEdit; }
  public isDistributionApp() { return this === EnumUserPermission.distributionApp; }
  public isPriceListsView() { return this === EnumUserPermission.priceListsView; }
  public isPriceListsEdit() { return this === EnumUserPermission.priceListsEdit; }
  public isReporting() { return this === EnumUserPermission.reporting; }
  public isAdministration() { return this === EnumUserPermission.administration; }
  public isBatchesView() { return this === EnumUserPermission.batchesView; }
  public isBatchesEdit() { return this === EnumUserPermission.batchesEdit; }
  public isRecipesView() { return this === EnumUserPermission.recipesView; }
  public isRecipesEdit() { return this === EnumUserPermission.recipesEdit; }
  public isVesselsView() { return this === EnumUserPermission.vesselsView; }
  public isVesselsEdit() { return this === EnumUserPermission.vesselsEdit; }
  public isMenuCalendarView() { return this === EnumUserPermission.menuCalendarView; }
  public isMenuTasksView() { return this === EnumUserPermission.menuTasksView; }
  public isMenuSalesView() { return this === EnumUserPermission.menuSalesView; }
  public isMenuContactsView() { return this === EnumUserPermission.menuContactsView; }
  public isMenuStockView() { return this === EnumUserPermission.menuStockView; }
  public isMenuDistributionView() { return this === EnumUserPermission.menuDistributionView; }
  public isMenuProductionView() { return this === EnumUserPermission.menuProductionView; }
  public isMenuUllagesView() { return this === EnumUserPermission.menuUllagesView; }
  public isMenuPricingView() { return this === EnumUserPermission.menuPricingView; }
  public isMenuContainerTrackingView() { return this === EnumUserPermission.menuContainerTrackingView; }
  public isMenuDutyView() { return this === EnumUserPermission.menuDutyView; }
  public isMenuReportingView() { return this === EnumUserPermission.menuReportingView; }
  public isMenuIntegrationsView() { return this === EnumUserPermission.menuIntegrationsView; }
  public isMenuAdministrationView() { return this === EnumUserPermission.menuAdministrationView; }
  public isMenuDistributionAppView() { return this === EnumUserPermission.menuDistributionAppView; }
  public isMenuMultiTenantView() { return this === EnumUserPermission.menuMultiTenantView; }
  public isMultiTenant() { return this === EnumUserPermission.multiTenant; }

  public static getValues(): readonly EnumUserPermission[] {
    return EnumUserPermission.allValues;
  }

  public static getValuesExcept0(): readonly EnumUserPermission[] {
    return EnumUserPermission.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUserPermission {
    const found = EnumUserPermission.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUserPermission - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUserPermission): EnumUserPermission {
    const found = name ? EnumUserPermission.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUserPermission - Value not found: ${ name }`);
    }

    return found;
  }
}